import { render, staticRenderFns } from "./LoadOrdersFilter.vue?vue&type=template&id=60b30822"
import script from "./LoadOrdersFilter.vue?vue&type=script&lang=js"
export * from "./LoadOrdersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports